import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { mapState } from 'vuex';
import { advertiserList } from "@/api/Administration/advertiser";
import { playerRetain } from "@/api/dataAll/retentionAnalysis";
export default {
  mixins: [],
  data: function data() {
    return {
      tableData: [],
      retentionPrimitive: [],
      RRlist: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
      retentionSelect: [],
      retention: [],
      analyzetypeList: [{
        label: '用户ID',
        value: 'user',
        disabled: true
      }, {
        label: '设备ID',
        value: 'device',
        disabled: false
      }],
      Dynamic: [],
      notEqual: ['activity', 'register', 'create_role'],
      advertiserLists: [],
      loadingBtn: false,
      cellStylekeys: ["number"]
    };
  },
  created: function created() {
    var _this = this;

    this.getsearchDate();
    this.RRlist.forEach(function (i, index) {
      var data = {
        label: i == 1 ? '次留' : i + 1 + '留',
        prop: "".concat(i, "t"),
        value: i
      };

      _this.retentionPrimitive.push(data);

      _this.retentionSelect.push(data.prop);
    });
    this.searchData.retain_days = this.retentionPrimitive[this.retentionPrimitive.length - 1].value;
    this.retention = this.retentionPrimitive;
  },
  activated: function activated() {
    this.getadvertiserList();
  },
  computed: {},
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    getadvertiserList: function getadvertiserList() {
      var _this2 = this;

      advertiserList().then(function (res) {
        if (res.status == 200) {
          _this2.advertiserLists = res.data;
        }
      });
    },
    beginactionChange: function beginactionChange(e, type) {
      var _this3 = this;

      if (type == '1') {
        var begIndex = this.behaviorList.findIndex(function (i) {
          return i.value == e;
        });
        this.searchData.retain_action = this.behaviorList.findIndex(function (i) {
          return i.value == _this3.searchData.retain_action;
        }) < begIndex || this.notEqual.findIndex(function (k) {
          return k == _this3.searchData.begin_action > -1;
        }) && this.searchData.begin_action == this.searchData.retain_action ? '' : this.searchData.retain_action;
        this.rehaviorList.map(function (i, ind) {
          i.disabled = ind < begIndex || ind <= begIndex && _this3.notEqual.findIndex(function (k) {
            return k == _this3.searchData.begin_action;
          }) > -1 ? true : false;
        });
      }

      this.analyzetypeList[0].disabled = this.searchData.begin_action == 'activity' || this.searchData.retain_action == 'activity' ? true : false;
      this.searchData.analyze_type = this.searchData.begin_action == 'activity' || this.searchData.retain_action == 'activity' ? 'device' : 'user';
    },
    retentionSelectChange: function retentionSelectChange(e) {
      var list = [];
      this.retentionPrimitive.forEach(function (i) {
        if (e.findIndex(function (t) {
          return t == i.prop;
        }) > -1) {
          list.push(i);
        }
      });
      this.retention = list;
    },
    searchClick: function searchClick() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.timeInterval();

              case 2:
                _this4.searchData.begin_date = _this4.value2[0];
                _this4.searchData.end_date = _this4.value2[1];
                _this4.loadingBtn = true;
                playerRetain(_this4.searchData).then(function (res) {
                  if (res.status == 200) {
                    _this4.Dynamic = [];
                    _this4.tableData = [];

                    var _loop = function _loop(i) {
                      var d = {
                        date: i,
                        totalNum: res.data[i]['r0']
                      };
                      var num = 0;
                      var keyList = Object.keys(res.data[i]).sort(function (a, b) {
                        return a.substring(1) - b.substring(1);
                      });
                      keyList.forEach(function (k) {
                        num++;

                        if (_this4.Dynamic.length < _this4.searchData.retain_days) {
                          _this4.Dynamic.push({
                            label: (num == 1 ? '当' : num == 2 ? '次' : num + 1) + '日留存',
                            prop: 'number' + num + ',' + 'rate' + num,
                            desc: num == 1 ? '当日账号留存率' : num == 2 ? '次日留存' : ''
                          });
                        }

                        if (k !== 'r0') {
                          d['number' + (num - 1)] = res.data[i][k].number;
                          d['rate' + (num - 1)] = (res.data[i][k].rate * 100).toFixed(2);
                        }
                      });

                      _this4.tableData.push(d);
                    };

                    for (var i in res.data) {
                      _loop(i);
                    }
                  } // this.getechart()

                }).finally(function () {
                  _this4.loadingBtn = false;
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    exportdata: function exportdata() {
      var data = this.tableData;

      var columns = _toConsumableArray(this.retention);

      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};